import nProgress from 'nprogress'

import { axiosClient } from '../../../../services/axiosInstance'
import { OrderForm } from '../../entity/orderForm'

export const addCartCoupon = async (orderFormId: string, coupon: string) => {
  nProgress.start()

  const { data } = await axiosClient.post(
    `/api/checkout/orderForm/${orderFormId}/coupons`,
    {
      text: coupon,
    }
  )

  nProgress.done()

  return new OrderForm(data)
}
